export default __webpack_public_path__ + "static/media/warning--traffic-merges-left-and-right--g1.b5ae91c4.png";